
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"
import BestaetigenReservierungNeuLogic from "@/logic/bestellung_neu/bestaetigen_reservierung_neu_logic"
import { LoadState } from "mangdto"

@Component({ components: { FilialeHeader, NichtGueltig } })
export default class BestaetigenReservierungNeu extends mixins(Calculator) {
  logic: BestaetigenReservierungNeuLogic = null

  LoadState = LoadState

  mounted() {
    this.logic = new BestaetigenReservierungNeuLogic()
    this.logic.init()
  }

  reservierungBestaetigen() {
    this.logic.reservierungBestaetigen()
  }
}
